module.exports = __webpack_public_path__ + "static/media/logo1.88ed96d5.png";